<template>
    <div id="content" class="container-xxl">
        <slot />
    </div>
</template>